// [목적] 홈 "강원 축제" 섹션 GET /festivals 공개 조회 API의 BE/FE 공유 zod 스키마 + 타입
// [이유] 계약 확정(2026-07-20 FE 병렬 구현) — status(ongoing/upcoming/unknown/ended)는 서버가 KST 오늘 기준으로 계산해
//        내려주고 FE는 그대로 렌더. addr1/sigunguCd51/overview는 TourAPI 원본(변형 금지, CLAUDE §4) — overview는
//        Silver poi.overview 미보강 상태(0건)라 null 허용.
// [사이드 이팩트] 없음(순수 스키마 정의).
// [수정 시 고려사항] startDate/endDate는 'YYYYMMDD' 8자리 문자열(TourAPI 원본 포맷 보존) — Date 파싱 없이 그대로 전달.
//                   status enum 추가 시 BE festival-status.util.ts의 computeFestivalStatus와 동기 갱신 필수.

import { z } from 'zod';

/**
 * 축제 진행 상태 — BE가 KST 오늘 기준으로 계산해 확정.
 * unknown은 원천에 시작일 또는 종료일이 없어 일정 상태를 판단할 수 없는 축제다.
 */
export const festivalStatusSchema = z.enum(['ongoing', 'upcoming', 'unknown', 'ended']);

export type FestivalStatus = z.infer<typeof festivalStatusSchema>;

/** GET /festivals 쿼리 파라미터 — limit 기본 12, 최대 36(is_festival=true 전체 행수) */
export const festivalListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(36).default(12),
});

export type FestivalListQuery = z.infer<typeof festivalListQuerySchema>;

/** GET /festivals 응답 아이템 — 홈 축제 카드 렌더용 */
export const festivalItemSchema = z.object({
  contentId: z.string(),
  title: z.string(),
  addr1: z.string().nullable(),
  sigunguCd51: z.string().nullable(),
  startDate: z.string(),
  endDate: z.string(),
  firstImage: z.string().nullable(),
  overview: z.string().nullable(),
  status: festivalStatusSchema,
});

export type FestivalItem = z.infer<typeof festivalItemSchema>;

/** GET /festivals 응답 data 필드 — envelope 안 배열 그대로 */
export const festivalListResponseSchema = z.array(festivalItemSchema);

export type FestivalListResponse = z.infer<typeof festivalListResponseSchema>;
